var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmilePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167.304,
    height: 107.049,
    viewBox: "0 0 167.304 107.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20075",
    "data-name": "Group 20075",
    transform: "translate(-1018.906 -933.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20067",
    "data-name": "Group 20067",
    transform: "translate(1077.975 952.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44001",
    "data-name": "Path 44001",
    d: "M45.447,7.632a9.345,9.345,0,0,0-6.739-6.607C32.523-.976,23.31.551,18.6.682a25.191,25.191,0,0,0-7.423.948A9.16,9.16,0,0,0,6.858,4.841a12.661,12.661,0,0,0-2.264,6.133,88.813,88.813,0,0,0-.211,9.055c-.158,6.528-.369,13.161-.342,19.637,0,4.4.158,8.792.474,13.161a.79.79,0,0,0,.816.711.763.763,0,0,0,.711-.895c-.237-4.317-.316-8.66-.237-13,0-6.528.474-13.161.763-19.584a86.473,86.473,0,0,1,.395-8.818,10.213,10.213,0,0,1,1.9-4.922,6.633,6.633,0,0,1,3.185-2.29,1.4,1.4,0,0,0,.316,0,21.742,21.742,0,0,0,.29,3.685A5.844,5.844,0,0,0,13.7,10.027a3.106,3.106,0,0,0,1.316.921,9.713,9.713,0,0,0,2.632.579c2.632.316,15.32-.632,15.5-.658a5.265,5.265,0,0,0,2.869-1.342,4.843,4.843,0,0,0,1.132-2.264,22.821,22.821,0,0,0,.474-3.5,6.712,6.712,0,0,1,5,4.659A64.649,64.649,0,0,1,43,19.293c0,9.055-.553,20.874-.658,26.323,0,1.816.211,4.975,0,7.9a7.107,7.107,0,0,1-1.553,4.027,10.24,10.24,0,0,1-5.659,2.5c-3.5.605-7.4.421-10.529.658a50.961,50.961,0,0,1-11.477.342,9.766,9.766,0,0,1-6.344-3,.842.842,0,0,0-1.211,0,.869.869,0,0,0,0,1.211,11.661,11.661,0,0,0,7.4,3.712,54.462,54.462,0,0,0,11.951,0c3.053-.237,7,0,10.529-.5a12.556,12.556,0,0,0,6.923-3.053,7.9,7.9,0,0,0,1.948-4.159,55.278,55.278,0,0,0,.474-9.371c.184-5.475.842-17.294,1-26.323a59.964,59.964,0,0,0-.342-11.924ZM35.339,6.078a3.685,3.685,0,0,1-.869,1.816,3.659,3.659,0,0,1-2.369.526c-15.162.342-11.529.632-14.214.526H16.334c-.553,0-.737,0-.921-.263a4.317,4.317,0,0,1-.948-2.132,22.717,22.717,0,0,1-.447-2.9,38.772,38.772,0,0,1,4.659-.237,89.233,89.233,0,0,1,16.61-.237l.605.132c-.158.869-.369,1.948-.553,2.764Z",
    transform: "translate(0 0)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44002",
    "data-name": "Path 44002",
    d: "M18.028,19.992a9.5,9.5,0,0,1-3.264-.842,10.529,10.529,0,0,1-5.133-4.843.763.763,0,0,0-.974-.447.79.79,0,0,0-.447,1,11.924,11.924,0,0,0,5.265,6.712,10,10,0,0,0,4.317,1.342,9.555,9.555,0,0,0,4.528-.842,11.293,11.293,0,0,0,3.106-2.29,21.058,21.058,0,0,0,3.132-4.449.9.9,0,0,0-.29-1.211.869.869,0,0,0-1.185.316,19.374,19.374,0,0,1-2.632,3.106,9.055,9.055,0,0,1-3.185,2A7.9,7.9,0,0,1,18.028,19.992Z",
    transform: "translate(6.73 22.544)",
    fill: "#f15223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44003",
    "data-name": "Path 44003",
    d: "M12.705,9.007a4.422,4.422,0,0,0-1.606.184,5.58,5.58,0,0,0-2,.948A9.661,9.661,0,0,0,6.23,13.85.737.737,0,0,0,6.467,14.9a.763.763,0,0,0,1.053-.211,9.266,9.266,0,0,1,3.132-2.237,5.422,5.422,0,0,1,2.027-.605,3.58,3.58,0,0,1,3.211,1.421.872.872,0,0,0,1.448-.974,5.5,5.5,0,0,0-4.633-3.29Z",
    transform: "translate(3.366 14.682)",
    fill: "#f15223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44004",
    "data-name": "Path 44004",
    d: "M14.256,13.826a6.133,6.133,0,0,1,2.817-1.79,4.054,4.054,0,0,1,1.106-.184,4.449,4.449,0,0,1,3.764,2,.862.862,0,1,0,1.474-.895,6.949,6.949,0,0,0-3.053-3.475,4.659,4.659,0,0,0-2.211-.553,4.343,4.343,0,0,0-2.185.553,7.028,7.028,0,0,0-2.975,3.5.711.711,0,0,0,.211,1.053A.763.763,0,0,0,14.256,13.826Z",
    transform: "translate(14.371 14.574)",
    fill: "#f15223"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20068",
    "data-name": "Group 20068",
    transform: "translate(988.5 841.538)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44005",
    "data-name": "Path 44005",
    d: "M52.484,141.261c7.133,2.582,14.307,5.447,21.2,8.644",
    transform: "translate(-10.714 -24.64)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44006",
    "data-name": "Path 44006",
    d: "M110.373,167.531c.788.366,1.586.706,2.382,1.052",
    transform: "translate(-40.269 -38.053)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44007",
    "data-name": "Path 44007",
    d: "M31.5,181.913c7.672.766,15.377,1.108,23.052,1.823",
    transform: "translate(0 -45.395)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44008",
    "data-name": "Path 44008",
    d: "M33.9,233.271c10.426-5.735,21.035-11.274,31.82-16.382",
    transform: "translate(-1.225 -63.253)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44009",
    "data-name": "Path 44009",
    d: "M115.523,107.083c5.3,7.323,9.727,15.212,14.927,22.6",
    transform: "translate(-42.899 -7.19)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44010",
    "data-name": "Path 44010",
    d: "M161.783,94.9c.945,2.332,1.929,4.658,2.723,7.048",
    transform: "translate(-66.517 -0.971)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44011",
    "data-name": "Path 44011",
    d: "M172.164,126.305c.145.491.284.985.442,1.473",
    transform: "translate(-71.818 -17.004)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44012",
    "data-name": "Path 44012",
    d: "M235.1,93c-3.4,5.478-7.418,10.774-10.054,16.685",
    transform: "translate(-98.815 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44014",
    "data-name": "Path 44014",
    d: "M275.347,117.932c-8.219,7.091-16.722,13.8-24.992,20.808",
    transform: "translate(-111.739 -12.729)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44015",
    "data-name": "Path 44015",
    d: "M313.354,153.358c-12.576,5.3-25.443,11.361-38.385,15.646",
    transform: "translate(-124.306 -30.816)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44016",
    "data-name": "Path 44016",
    d: "M314.508,139.257c1.892-1.144,3.77-2.311,5.669-3.442",
    transform: "translate(-144.493 -21.86)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44017",
    "data-name": "Path 44017",
    d: "M324.618,212.259c-14.126-1.114-28.389-.037-42.446,1.483",
    transform: "translate(-127.983 -60.655)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44018",
    "data-name": "Path 44018",
    d: "M64.475,268.535c4.949-4.52,9.73-9.339,14.821-13.7",
    transform: "translate(-16.836 -82.628)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44019",
    "data-name": "Path 44019",
    d: "M109.5,238.717c1.071-1.092,2.121-2.219,3.287-3.211",
    transform: "translate(-39.825 -72.758)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44020",
    "data-name": "Path 44020",
    d: "M144.944,246.775c-1.678,4.186-3.245,8.414-5.053,12.546",
    transform: "translate(-55.34 -78.511)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44021",
    "data-name": "Path 44021",
    d: "M179.44,255.934c-.72,6.7-1.052,13.428-1.829,20.117",
    transform: "translate(-74.599 -78.488)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44023",
    "data-name": "Path 44023",
    d: "M222.914,274.31a112.3,112.3,0,0,0,4.753,12.809",
    transform: "translate(-97.728 -92.57)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44024",
    "data-name": "Path 44024",
    d: "M249.975,241.887a171.107,171.107,0,0,1,18.107,23.149",
    transform: "translate(-111.545 -76.016)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44025",
    "data-name": "Path 44025",
    d: "M281.559,237.869c1.04.92,2.063,1.844,3.166,2.688",
    transform: "translate(-127.67 -73.964)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44026",
    "data-name": "Path 44026",
    d: "M306.256,254.068c3.146,2.825,6.645,5.192,9.787,8",
    transform: "translate(-140.28 -82.235)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilePhone);
export default __webpack_public_path__ + "static/media/smilePhone.73b7d94741913ca62f253c5e951d742f.svg";
export { ForwardRef as ReactComponent };